var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgJob = function SvgJob(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19.25,
    height: 18.13,
    viewBox: "0 0 19.25 18.13",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-_4_modu\\u0142_internetowych_ofert_pracy"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.25,
    height: 18.13
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_4_modu\\u0142_internetowych_ofert_pracy",
    "data-name": "4 modu\\u0142 internetowych ofert pracy",
    clipPath: "url(#clip-_4_modu\\u0142_internetowych_ofert_pracy)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "briefcase",
    d: "M18.87,18.178H14.527v-1.8a1.519,1.519,0,0,0-1.515-1.519H6.322a1.519,1.519,0,0,0-1.515,1.519v1.8H.376A.376.376,0,0,0,0,18.554v6.258a.376.376,0,0,0,.376.376H.8v7.42a.376.376,0,0,0,.376.376H18.069a.376.376,0,0,0,.376-.376v-7.42h.425a.376.376,0,0,0,.376-.376V18.554a.376.376,0,0,0-.376-.376Zm-13.311-1.8a.766.766,0,0,1,.763-.768h6.689a.766.766,0,0,1,.763.768v1.8H12.73V17.036a.376.376,0,0,0-.376-.376H6.98a.376.376,0,0,0-.376.376v1.143H5.559Zm1.8,1.8v-.767h4.622v.767ZM17.693,32.233H1.553V25.189H3.3v2.419a.376.376,0,0,0,.376.376H6.381a.376.376,0,0,0,.376-.376V25.189h5.732v2.419a.376.376,0,0,0,.376.376h2.707a.376.376,0,0,0,.376-.376V25.189h1.745Zm-13.643-5V23.469H6v3.763Zm9.191,0V23.469H15.2v3.763Zm5.253-2.8H15.948V23.093a.376.376,0,0,0-.376-.376H12.865a.376.376,0,0,0-.376.376v1.344H6.757V23.093a.376.376,0,0,0-.376-.376H3.674a.376.376,0,0,0-.376.376v1.344H.752V18.93H18.494Z",
    transform: "translate(0 -14.856)",
    fill: "#a8b0b6"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgJob, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/job.532c05f6.svg";
export { ForwardRef as ReactComponent };